module.exports = __webpack_public_path__ + "static/media/mas.4c0d5ed8.svg";